module.exports = __webpack_public_path__ + "static/no-scene-3-cover-thumbnail-90adcdc2d012bffb52d4065dd323bd4c.jpg";